
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Aabadi=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Aabadi Picnic Spot</h1>
           <p className="sub-heading">Known as Mini Goa of Sonbhadra: Lush green forests meet serene valleys and river</p>
         </div>
         <div className="description">
         Nestled in the picturesque Kota Gram Panchayat of Sonbhadra, Aabadi Picnic Spot is a hidden gem surrounded by verdant forests, rolling hills, and a tranquil river stream. This natural haven attracts visitors from across India, offering a perfect blend of scenic beauty and peaceful vibes. With efforts underway to enhance its facilities and ensure forest conservation, Aabadi promises an unforgettable retreat for all who visit.</div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi1.jpeg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Abadi Picnic Spot/abadi7.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
         </div>
   
         <BookSection />
       </div>
     );
};